const VALIDATION_MESSAGES = {
  'fauOrOther1': "Please select only one checkbox: FAU or Other.",
  'fauOrOther2': "Please select only one checkbox: FAU or Other.",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "preTest4_isFAU": () => ({
      validate: () => {
        const fauOther = ["preTest4_isFAU", "preTest4_isOtherType"];
        const count = fauOther.filter(checked => !!getValues(checked)).length;
        return (count === 1) || VALIDATION_MESSAGES['fauOrOther1'];
      },
    }),
    "postTest4_isFAU": () => ({
      validate: () => {
        const fauOther = ["postTest4_isFAU", "postTest4_isOtherType"];
        const count = fauOther.filter(checked => !!getValues(checked)).length;
        return (count === 1) || VALIDATION_MESSAGES['fauOrOther2'];
      },
    }),
  };
};

export default useValidation;
